import { ComponentProps, memo } from "react"
import { Colors } from "src/constants/Colors"
import { Button } from "src/components/parts/buttons/Button"
import { BackIcon } from "../icons/BackIcon"

export const ButtonBackIcon = memo<ComponentProps<typeof Button>>((props) => {

  return (
    <Button {...props}>
      <BackIcon fill={Colors.white3} />
    </Button>
  )
})
